<template>
  <el-select
    v-model="model.blogs"
    filterable
    remote
    reserve-keyword
    :disabled="disabled"
    clearable
    value-key="id"
    :remote-method="fetchSearchedBlogs"
    :loading="loading"
    :multiple="true"
    @change="selectBlogs">
    <el-option
      v-for="blog in searchedBlogs"
      :key="blog.id"
      :label="blog.title[lang]"
      :value="blog">
      <span style="margin-left:5px; color: #8492a6; font-size: 13px">{{ blog.title[lang] }}</span>
    </el-option>
  </el-select>
</template>
<script>
import cmsAPI from '@/services/API/cmsAPI'
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
	name: 'SelectCMSBlogs',
  props: {
		blogs : {
      type : Array
    },
    disabled: {
      type: Boolean,
      default: false
    }
	},
	data() {
		return {
      model : {
        blogs : null
      },
      searchedBlogs : [],
      loading : false
	   }
   },
  computed: {
    lang(){
      return this.$i18n.locale
    },
    ...mapGetters(['getLocale']),
  },
  components : {
  },
  methods : {
    selectBlogs(blogs){
      this.$emit('selected', blogs);
    },
    fetchSearchedBlogs(query){
      this.loading = true;
      return cmsAPI.fetchCMSBlogs({t:query,paging:'no', active:this.active}, this.getLocale)
      .then(searchedBlogs => {
        this.searchedBlogs = searchedBlogs;
        this.loading = false;
      });
    },
    getCMSBlogById(blogId){
      return cmsAPI.getCMSBlog(blogId)
    }
  },
  watch: {
    blogs: function(newBlogs, oldBlogs) {
      if (newBlogs == null) {
        this.model.blogs = null;
        this.searchedBlogs = [];
      } else {
        this.searchedBlogs = newBlogs;
        this.model.blogs = newBlogs;
      }

    }
  },
  created(){
    if(!_.isEmpty(this.blogs)){
      this.searchedBlogs.push(this.blogs);
      this.model.blogs = this.blogs;
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
